// NPM Imports
import React from "react";

// Internal Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@revvsales/components";

export default function ContentLock(props) {
  if (!props.section.lock) {
    return (
      <Tooltip
        placement="top"
        overlay={
          props.isDisabled
            ? "Cannot lock this block as it is added as a clause option "
            : "Lock this block"
        }
        align={{ offset: [0, 3] }}>
        <span
          className={`btn-icon ${props.isDisabled ? "disabled-lock" : ""}`}
          data-test="documentitems-lock-the-content-btn"
          id="lock-the-content-btn"
          onMouseDown={event => props.toggleSectionLock(event, true)}
          role="button"
          tabIndex={0}>
          <FontAwesomeIcon icon={["far", "unlock"]} />
        </span>
      </Tooltip>
    );
  }
  return (
    <Tooltip
      placement="top"
      overlay="Unlock this block"
      align={{ offset: [0, 3] }}>
      <span
        className={`btn-icon locked-icon ${
          props.isDisabled ? "disabled-lock" : ""
        }`}
        data-test="documentitems-unlock-the-content-btn"
        id="unlock-the-content-btn"
        onMouseDown={event => props.toggleSectionLock(event, false)}
        role="button"
        tabIndex={0}>
        <FontAwesomeIcon icon={["far", "lock"]} />
      </span>
    </Tooltip>
  );
}



// WEBPACK FOOTER //
// ./src/components/DocumentItems/ContentLock/ContentLock.js